document.addEventListener('DOMContentLoaded', function() {
    // Vérifier si des éléments tabs existent avant d'initialiser
    if (document.querySelectorAll('.tab-btn').length > 0) {
        const tabBtns = document.querySelectorAll('.tab-btn');
        const tabContents = document.querySelectorAll('.tab-content');
        const tabsContainer = tabBtns[0].parentElement;
        let activeTab = null;
        
        // Créer l'indicateur de border animé
        const indicator = document.createElement('div');
        indicator.className = 'tab-indicator';
        indicator.style.cssText = `
            position: absolute;
            bottom: 0;
            height: 2px;
            background-color: black;
            transition: transform 0.3s ease, width 0.3s ease;
            z-index: 1;
        `;
        tabsContainer.style.position = 'relative';
        tabsContainer.appendChild(indicator);

        function showTab(tab) {
            tabContents.forEach(content => {
                if (content.getAttribute('data-tab') === tab) {
                    content.style.display = 'flex';
                    content.style.position = 'static';
                    // Transition d'entrée
                    setTimeout(() => {
                        content.style.opacity = '1';
                        content.style.transform = 'translateY(0)';
                        content.style.pointerEvents = 'auto';
                    }, 10);
                } else {
                    // Transition de sortie
                    content.style.opacity = '0';
                    content.style.transform = 'translateY(10px)';
                    content.style.pointerEvents = 'none';
                    setTimeout(() => {
                        content.style.display = 'none';
                    }, 300);
                }
            });

            tabBtns.forEach(b => b.classList.remove('font-bold'));
            const btn = Array.from(tabBtns).find(b => b.getAttribute('data-tab') === tab);
            if (btn) {
                btn.classList.add('font-bold');
                
                // Animer l'indicateur vers le bouton actif
                const btnRect = btn.getBoundingClientRect();
                const containerRect = tabsContainer.getBoundingClientRect();
                const left = btn.offsetLeft;
                const width = btnRect.width;
                
                indicator.style.transform = `translateX(${left}px)`;
                indicator.style.width = `${width}px`;
            }
            activeTab = tab;
        }
        
        tabBtns.forEach(btn => {
            btn.addEventListener('click', function () {
                const tab = this.getAttribute('data-tab');
                if (tab !== activeTab) showTab(tab);
            });
        });
        
        // Active le premier tab par défaut
        if (tabBtns[0]) showTab(tabBtns[0].getAttribute('data-tab'));
    }
});